var _radialGradient, _path, _linearGradient, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanvaImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "128px",
    height: "128px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "U0xW9~4yZ8OpqogDQDvGQa",
    cx: 32,
    cy: 622.5,
    r: 31.259,
    gradientTransform: "matrix(1 0 0 -1 0 654)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#cdf3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#e4faff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9fbff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U0xW9~4yZ8OpqogDQDvGQa)",
    d: "M58,54c-1.105,0-2-0.895-2-2s0.895-2,2-2h2.5c1.925,0,3.5-1.575,3.5-3.5S62.425,43,60.5,43H50 c-1.381,0-2.5-1.119-2.5-2.5S48.619,38,50,38h8c1.65,0,3-1.35,3-3s-1.35-3-3-3H42v-6h18c2.335,0,4.22-2.028,3.979-4.41 C63.77,19.514,61.897,18,59.811,18H58c-1.105,0-2-0.895-2-2s0.895-2,2-2h0.357c1.308,0,2.499-0.941,2.63-2.242 C61.137,10.261,59.966,9,58.5,9h-14C43.672,9,43,8.328,43,7.5S43.672,6,44.5,6h3.857c1.308,0,2.499-0.941,2.63-2.242 C51.137,2.261,49.966,1,48.5,1H15.643c-1.308,0-2.499,0.941-2.63,2.242C12.863,4.739,14.034,6,15.5,6H19c1.105,0,2,0.895,2,2 s-0.895,2-2,2H6.189c-2.086,0-3.958,1.514-4.168,3.59C1.78,15.972,3.665,18,6,18h2.5c1.933,0,3.5,1.567,3.5,3.5S10.433,25,8.5,25 H5.189c-2.086,0-3.958,1.514-4.168,3.59C0.78,30.972,2.665,33,5,33h17v11H6c-1.65,0-3,1.35-3,3s1.35,3,3,3l0,0c1.105,0,2,0.895,2,2 s-0.895,2-2,2H4.189c-2.086,0-3.958,1.514-4.168,3.59C-0.22,59.972,1.665,62,4,62h53.811c2.086,0,3.958-1.514,4.168-3.59 C62.22,56.028,60.335,54,58,54z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U0xW9~4yZ8OpqogDQDvGQb",
    x1: 52.984,
    x2: 11.623,
    y1: 57.143,
    y2: 11.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#823af3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4b66e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#01f1c4"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#U0xW9~4yZ8OpqogDQDvGQb)",
    d: "M50,12H14c-2.209,0-4,1.791-4,4v36c0,2.209,1.791,4,4,4h36c2.209,0,4-1.791,4-4V16 C54,13.791,52.209,12,50,12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M40.451,41.953c-1.478,1.359-2.438,2.293-4.588,3.392 c-1.232,0.615-2.617,0.985-3.924,0.985c-3.921,0-5.833-3.61-6.214-6.728c-0.977-7.999,6.052-18.994,10.953-18.994 c1.143,0,2.164,0.994,2.354,2.543c0.294,2.411,0.246,4.12-2.247,6.203c-0.273,0.227-0.353,0.596-0.212,0.814 c0.212,0.326,0.882,0.359,2.236-0.326c2.652-1.338,3.608-3.404,3.316-5.796c-0.325-2.654-2.641-4.876-5.747-4.876 c-1.51,0-3.171,0.451-4.654,1.354c-6.463,3.937-10.633,12.921-9.795,19.773c0.265,2.174,1.169,4.554,2.876,6.154 c1.151,1.066,3.231,2.379,5.683,2.379c2.655,0,4.897-1.025,6.908-2.294c1.363-0.873,2.503-1.929,3.466-3.01 C42.441,42.058,41.305,41.147,40.451,41.953z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvaImg);
export default __webpack_public_path__ + "static/media/canvaImg.c12565170e6f8ee4670cd4dc4fa7247f.svg";
export { ForwardRef as ReactComponent };